import { Thread } from '../conversational/thread.model';
import { FocusRange } from '../focus-range.model';
import { ConversationalTheme } from '../types/all';
import { NotificationEventType } from '../types/notification-event-type';

import { Icon, WattsonNotification } from './wattson-notification.model';

/**
 * Model for API Thread Notification Model
 */
export class ThreadNotification extends WattsonNotification {
  /**
   * The target of the notification is a Thread.
   */
  declare target: Thread;

  constructor(attributes: Partial<ThreadNotification> = {}) {
    super();
    Object.assign(this, attributes);
  }

  getIcons(): Icon[] {
    return this.target.themes.map((theme: ConversationalTheme) => ({
      icon: 'md-' + theme,
      tooltip: 'conversational.themes.' + theme,
    }));
  }

  getTypeIcon(): string {
    switch (this.eventType) {
      case NotificationEventType.mentionedInThread:
        return 'alternate_email';
      case NotificationEventType.newThreadInScope:
        return 'chat';
      case NotificationEventType.newCommentInPublicThread:
        return 'reply';
      default:
        return 'face';
    }
  }

  getNotificationAuthor(): string {
    switch (this.eventType) {
      case NotificationEventType.newCommentInPublicThread:
        return this.target.comments[0].author.toString();
      default:
        return this.target.author.toString();
    }
  }

  getNotificationMessage(): string {
    return `notification_panel.${this.category}.${this.eventType}`;
  }

  getFocus(): FocusRange[] {
    return this.target.focusList;
  }

  getLink(): string {
    return `/thread/public/${this.target.id}`;
  }
}
